<template>
  <div v-loading="loading">
    <el-card>
      <el-descriptions :column="2" :contentStyle="{ height: '35px' }">
        <el-descriptions-item label="申请编号">
          {{ info.idNo }}
        </el-descriptions-item>
        <el-descriptions-item label="申请评审机构">
          {{ info.fromBoardName }}
        </el-descriptions-item>
        <el-descriptions-item label="授权评审区域">
          {{ info.applyStoreName }}
        </el-descriptions-item>
        <el-descriptions-item label="授权评审机构">
          {{ info.applyBoardName }}
        </el-descriptions-item>
        <el-descriptions-item label="授权评审专业">
          {{ info.speName }}
        </el-descriptions-item>
        <el-descriptions-item label="需共享人数">
          {{ info.applyCount }}
        </el-descriptions-item>
        <el-descriptions-item label="说明">
          {{ info.reason }}
        </el-descriptions-item>
        <el-descriptions-item label="新增时间">
          <span>{{ moment(info.addTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { getInfo } from '@/api/shares/base.js';

export default {
  data() {
    return {
      info: {},
      loading: false
    };
  },
  methods: {
    getInfo() {
      this.loading = true;
      getInfo(this.$route.params.shareEid).then(res => {
        this.info = res;
        this.loading = false;

        this.$emit(
          'set-title',
          `${res.fromBoardName}-${res.speName}-${res.applyCount}人`
        );
      });
    }
  },
  created() {
    this.getInfo();
  }
};
</script>

<style></style>
